import NodeInfo from "./NodeInfo/NodeInfo";
import RpcCalls from "./RpcCalls/RpcCalls";

export default {
    name: 'node-tools',
    template: require('./NodeTools.html'),
    components: { NodeInfo, RpcCalls }
}
